import { css } from '@emotion/react';
import { theme } from './theme';
import { tokens } from './tokens';

export const tableStyles = {
   headerBase: css`
      padding: ${tokens.space.sm} ${tokens.space.md};
      font-weight: ${tokens.font.weight.normal};
      font-size: ${tokens.font.size.sm};
      color: ${theme.colors.text.secondary};
      border-bottom: ${tokens.border.thin} ${theme.colors.border.default};
   `,

   cellBase: css`
      padding: ${tokens.space.sm} ${tokens.space.md};
      font-size: ${tokens.font.size.sm};
      color: ${theme.colors.text.primary};
      border-bottom: ${tokens.border.thin} ${theme.colors.bg.secondary};
   `,

   rowHover: css`
      &:hover {
         background-color: ${theme.colors.bg.secondary};
      }
   `,

   sortableHeader: css`
      cursor: pointer;
      user-select: none;

      &:hover {
         background-color: ${theme.colors.bg.secondary};
      }
   `,
};
